import {
  Button,
  Card,
  Col,
  Flex,
  Row,
  Spin,
  Steps,
  Typography,
  Statistic,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import "../../..";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "./financialInstrument.config";
import Preview from "./components/Preview";
import FeedbackModal from "./components/FeedbackModal";

import InstrumentIdentificationForm from "./components/InstrumentIdentificationForm";
import ClassificationFieldsForm from "./components/ClassificationFieldForm.js";
import InstrumentStructureForm from "./components/InstrumentStructureForm.js";
import PricingInformationForm from "./components/PricingInformation.js";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../components/CheckerModal.js";

const { Text } = Typography;

const multiFactorAuthenticationOptions = [
  { value: 0, label: "Enable" },
  { value: 1, label: "Disable" },
];

const AddFinancialInstrument = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;

  const location = useLocation();

  const selectedBranchKey = location.state?.id;
  const entity = location.state?.entity;

  const isEditMode = Boolean(selectedBranchKey);
  const navigate = useNavigate();

  const [current, setCurrent] = useState(0);

  const [productCateogory, setProductCategory] = useState([]);
  const [instrumentType, setinstrumentType] = useState([]);
  const [issuerType, setIssuerType] = useState([]);
  const [assetClass, setAssetClass] = useState([]);
  const [countryOfIssuer, setCountryOfIssuer] = useState([]);

  const [holiday, setHoliday] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [dayCountConventionOptions, setdayCountConventionOptions] = useState(
    [],
  );
  const [couponFrequencyOptions, setCouponFrequencyOptions] = useState([]);
  const [businessDayConventionOptions, setBusinessDayConventionOptions] =
    useState([]);
  //Market Type
  //Valuation Approach
  //Product Code

  const [QuotationType, setQuotationType] = useState([]);
  const [marketType, setMarketType] = useState([]);
  const [productCodes, setProductCodes] = useState([]);
  const [valuationApproach, setValuationApproach] = useState([]);

  const [formData, setFormData] = useState({
    instrumentIdentification: {},
    classificationFields: {},
    instrumentStructure: {},
    pricingInformation: {},
  });

  useEffect(() => {
    getSecurityInstrumentTemplate();
    getHoliday();
    if (isEditMode) {
      getSecurityInstrumentById(selectedBranchKey);
    }
  }, []);

  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isStepDisabled, setIsStepDisabled] = useState(true);

  const [form] = useForm();

  const getHoliday = () => {
    setIsLoading(true);

    let body = { session };
    const url = `${apiConfig.Holidays}?officeId=1`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempHoliday = [];

        objList.forEach((element) => {
          tempHoliday.push({
            value: element.name,
            label: element.name,
          });
        });
        setHoliday(tempHoliday);
      }
    });

    setIsLoading(false);
  };

  const getSecurityInstrumentTemplate = () => {
    setIsLoading(true);

    let body = { session };
    const url = `${apiConfig.GetSecurityInstrument}/template`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;

        console.log(objList);
        let tempProductCateogory = [];
        let tempInstrumentType = [];
        let tempAssetClass = [];
        let tempCountryOfIssuer = [];
        let tempCurrency = [];
        let tempDayCountConventionOptions = [];
        let tempCouponFrequencyOptions = [];
        let tempBusinessDayConventionOptions = [];
        let tempQuotationType = [];
        let tempMarketType = [];
        let tempProductCodes = [];
        let tempValuationApproach = [];
        let tempIssuerType = [];

        objList?.instrumentCategoryOptions?.forEach((element) => {
          tempProductCateogory.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.issueTypeOptions?.forEach((element) => {
          tempIssuerType.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.instrumentTypeOptions?.forEach((element) => {
          tempInstrumentType.push({
            value: element.id,
            label: element.text,
            code: element.code,
          });
        });

        objList?.assetClassOptions?.forEach((element) => {
          tempAssetClass.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.countryOptions?.forEach((element) => {
          tempCountryOfIssuer.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        objList?.dayCountConventionOptions?.forEach((element) => {
          tempDayCountConventionOptions.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.couponFrequencyOptions?.forEach((element) => {
          tempCouponFrequencyOptions.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.businessDayConventionOptions?.forEach((element) => {
          tempBusinessDayConventionOptions.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.quotationTypeOptions?.forEach((element) => {
          tempQuotationType.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.marketTypeOptions?.forEach((element) => {
          tempMarketType.push({
            value: element.id,
            label: element.text,
          });
        });

        objList?.valuationApproachOptions?.forEach((element) => {
          tempValuationApproach.push({
            value: element.id,
            label: element.text,
          });
        });
        objList?.bondProductOptions?.forEach((item) => {
          tempProductCodes.push({
            value: item.id,
            label: `${item.productName} (${item.productCode})`,
            productType: "bond",
          });
        });

        // 2. Treasury Bill Products
        objList?.treasuryBillProductOptions?.forEach((item) => {
          tempProductCodes.push({
            value: item.id,
            label: `${item.productName} (${item.productCode})`,
            productType: "treasuryBill",
          });
        });

        setProductCodes(tempProductCodes);

        setProductCategory(tempProductCateogory);
        setinstrumentType(tempInstrumentType);
        setAssetClass(tempAssetClass);
        setCountryOfIssuer(tempCountryOfIssuer);
        setCurrency(tempCurrency);
        setdayCountConventionOptions(tempDayCountConventionOptions);
        setCouponFrequencyOptions(tempCouponFrequencyOptions);
        setBusinessDayConventionOptions(tempBusinessDayConventionOptions);
        setQuotationType(tempQuotationType);
        setMarketType(tempMarketType);
        setValuationApproach(tempValuationApproach);
        setIssuerType(tempIssuerType);
      }
    });
    setIsLoading(false);
  };

  const getSecurityInstrumentById = (id) => {
    setIsLoading(true);

    const body = { session };
    const url = `${apiConfig.GetSecurityInstrument}/${id}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        return;
      }

      const identification = {
        instrumentName: res.instrumentName,
        isin: res.isin,
        cusip: res.cusip,
        localCode: res.internalCode,
      };

      const classification = {
        instrumentCategoryId: res.instrumentCategory?.id,
        instrumentTypeId: res.instrumentType?.id,
        assetClassId: res.assetClass?.id,
        countryId: res.country?.id,
        issueName: res?.issueName,
        issueTypeId: res.issueType?.id,
      };

      const structure = {
        faceValueDenomination: res.faceValueDenomination,
        currencyCode: res.currencyCode,
        issueDate: res.issueDate ? dayjs(res.issueDate.join("-")) : null,
        maturityDate: res.maturityDate
          ? dayjs(res.maturityDate.join("-"))
          : null,
        dayCountConventionId: res.dayCountConvention?.id,
        businessDayConventionId: res.businessDayConvention?.id,
        couponRate: res.couponRate,
        couponFrequencyId: res.couponFrequency?.id,
        couponBasis: res.couponBasis,
        resetIndex: res.resetIndex,
        holidayCalendar: res.holidayCalendar,
      };

      const pricing = {
        linkedProductId: res.linkedProductId,
        quotationTypeId: res.quotationType?.id,
        marketTypeId: res.marketType?.id,
        ticketSize: res.ticketSize,
        valuationApproachId: res.valuationApproach?.id,
      };

      setFormData({
        instrumentIdentification: identification,
        classificationFields: classification,
        instrumentStructure: structure,
        pricingInformation: pricing,
      });

      /* ---------------- SET ANT FORM VALUES ---------------- */
      form.setFieldsValue({
        ...identification,
        ...classification,
        ...structure,
        ...pricing,
      });
    });
  };

  const handleClose = () => {
    setSuccessModalVisible(false);
    setWarningModalVisible(false);
  };

  const stepTitles = [
    "Instrument Identification",
    "Classification Fields",
    "Instrument Structure",
    "Pricing Information",
    "Preview",
  ];

  const onChange = (value) => {
    setCurrent(value);
  };

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/security-instrument", { replace: false });
  }

  const onFinishInstrumentIdentificationForm = (values) => {
    console.log("Instrument Identification Data:", values);
    setFormData((prev) => ({
      ...prev,
      instrumentIdentification: values,
    }));
    setCurrent(current + 1);
  };

  const onFinishClassificationFieldsForm = (values) => {
    console.log("Classification Fields Data:", values);
    setFormData((prev) => ({
      ...prev,
      classificationFields: values,
    }));
    setCurrent(current + 1);
  };

  const onFinishInstrumentStructureForm = (values) => {
    // Convert date fields to YYYY-MM-DD
    const payload = {
      ...values,
      issueDate: values.issueDate
        ? values.issueDate.format("YYYY-MM-DD")
        : null,
      maturityDate: values.maturityDate
        ? values.maturityDate.format("YYYY-MM-DD")
        : null,
    };

    console.log("Instrument Structure Data:", payload);

    setFormData((prev) => ({
      ...prev,
      instrumentStructure: payload,
    }));

    setCurrent(current + 1);
  };

  const onFinishPricingInformationForm = (values) => {
    console.log("Pricing Information Data:", values);
    setFormData((prev) => ({
      ...prev,
      pricingInformation: values,
    }));
    setCurrent(current + 1);
  };

  const forms = [
    <InstrumentIdentificationForm
      key="instrument-identification"
      onFinish={onFinishInstrumentIdentificationForm}
      initialValues={formData.instrumentIdentification}
      form={form}
    />,
    <ClassificationFieldsForm
      key="classification-fields"
      onFinish={onFinishClassificationFieldsForm}
      initialValues={formData.classificationFields}
      form={form}
      productCateogory={productCateogory}
      instrumentType={instrumentType}
      assetClass={assetClass}
      countryOfIssuer={countryOfIssuer}
      issuerType={issuerType}
    />,
    <InstrumentStructureForm
      key="instrument-structure"
      onFinish={onFinishInstrumentStructureForm}
      initialValues={formData.instrumentStructure}
      currency={currency}
      dayCountConventionOptions={dayCountConventionOptions}
      couponFrequencyOptions={couponFrequencyOptions}
      businessDayConventionOptions={businessDayConventionOptions}
      form={form}
      instrumentTypeOptions={instrumentType}
      instrumentTypeId={formData.classificationFields.instrumentTypeId}
      holiday={holiday}
    />,

    <PricingInformationForm
      key="pricing-information"
      onFinish={onFinishPricingInformationForm}
      initialValues={formData.pricingInformation}
      form={form}
      QuotationType={QuotationType}
      marketType={marketType}
      valuationApproach={valuationApproach}
      productCodes={productCodes}
    />,

    <Preview
      key="preview"
      formData={formData}
      productCateogory={productCateogory}
      instrumentType={instrumentType}
      assetClass={assetClass}
      countryOfIssuer={countryOfIssuer}
      currency={currency}
      dayCountConventionOptions={dayCountConventionOptions}
      couponFrequencyOptions={couponFrequencyOptions}
      businessDayConventionOptions={businessDayConventionOptions}
      quotationTypeOptions={QuotationType}
      marketTypeOptions={marketType}
      valuationApproachOptions={valuationApproach}
      productCodes={productCodes}
      issueTypeId={issuerType}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const onSubmit = () => {
    const identification = formData.instrumentIdentification || {};
    const classification = formData.classificationFields || {};
    const structure = formData.instrumentStructure || {};
    const pricing = formData.pricingInformation || {};

    const payload = {
      instrumentName: identification.instrumentName,
      instrumentTypeId: classification.instrumentTypeId,
      currencyCode: structure.currencyCode,
      isin: identification.isin,
      cusip: identification.cusip || null,
      internalCode: identification.localCode,
      shortName: identification.instrumentName,

      instrumentCategoryId: classification.instrumentCategoryId,
      assetClassId: classification.assetClassId,
      countryId: classification.countryId,
      issueName: classification.issueName,
      issueTypeId: classification.issueTypeId,

      faceValueDenomination: Number(structure.faceValueDenomination),
      issueDate: structure.issueDate,
      maturityDate: structure.maturityDate,
      dayCountConventionId: structure.dayCountConventionId,
      businessDayConventionId: structure.businessDayConventionId,
      holidayCalendar: structure.holidayCalendar,
      couponRate: Number(structure.couponRate),
      couponFrequencyId: structure.couponFrequencyId,
      couponBasis: structure.couponBasis,
      resetIndex: structure.resetIndex,

      linkedProductId: pricing.linkedProductId,
      quotationTypeId: pricing.quotationTypeId,
      marketTypeId: pricing.marketTypeId,
      ticketSize: Number(pricing.ticketSize),
      valuationApproachId: pricing.valuationApproachId,

      locale: "en",
      dateFormat: "yyyy-MM-dd",
    };

    const url = isEditMode
      ? `${apiConfig.GetSecurityInstrument}/${selectedBranchKey}`
      : apiConfig.GetSecurityInstrument;

    const body = {
      ...payload,
      session,
      method: isEditMode ? "PUT" : "POST",
    };

    console.log(body);
    setIsLoading(true);

    BOM.FetchReqAction(
      body,
      url,
      (err) => {
        setIsLoading(false);

        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors?.[0]?.defaultUserMessage);
          return;
        }

        BOM.AlertMsg(
          cnt.SUCCESS,
          isEditMode
            ? "Financial Instrument Updated Successfully"
            : "Financial Instrument Created Successfully",
        );
        navigate("/security-instrument");
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/security-instrument", {
            state: {
              id: res.resourceId, // might be res.id, res.auditId, etc.
            },
          });
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout
      pageItems={
        selectedBranchKey
          ? staticConfig.editSecurityInstrument
          : staticConfig.newSecurityInstrument
      }
      onSave={onSubmit}
    >
      <TopContent
        pageTitle={labelConfig.securityInstrument}
        createPageTitle={
          selectedBranchKey
            ? labelConfig.editSecurityInstrument
            : labelConfig.addSecurityInstrument
        }
      />
      <Spin spinning={isLoading} size="large">
        <div
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            width: "100%",
          }}
        >
          {/* Navigation section */}
          <div style={{ width: "288px", padding: "20px 0" }}>
            <Steps
              className="custom-step-style"
              current={current}
              onChange={onChange}
              direction="vertical"
              style={{ height: "723px" }}
              items={[
                {
                  title: <Text strong>Instrument Identification</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Classification Fields</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Instrument Structure</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Pricing Information</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Preview</Text>,
                  disabled: isStepDisabled,
                },
              ]}
            />
          </div>

          {/* Form section */}
          <Card
            style={{
              borderRadius: 20,
              width: "100%",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              padding: "0 20px",
              height: `${current === forms.length - 1 ? "723px" : "100%"}`,
              overflowY: `${current === forms.length - 1 ? "auto" : "hidden"}`,
            }}
          >
            <div style={{ flexGrow: 1 }}>{forms[current]}</div>

            {/* Button Section (at bottom) */}
            <div
              style={{
                paddingTop: 30,
                borderRadius: 20,
              }}
            >
              <Flex justify="end" gap="30px" align="end">
                {current === 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={() => setWarningModalVisible(true)}
                  >
                    Go Back
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={prevButtonClick}
                  >
                    Previous
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={nextButtonClick}
                  >
                    Next - {stepTitles[current + 1]}
                  </Button>
                )}
                {isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={onSubmit}
                  >
                    {selectedBranchKey
                      ? "Edit Instrument"
                      : "Create Instrument"}
                  </Button>
                )}
              </Flex>
            </div>
          </Card>
        </div>
      </Spin>

      {/* Success Modal */}
      {/* <FeedbackModal
        visible={successModalVisible}
        type="success"
        onPrimaryAction={handleClose}
        onSecondaryAction={() => {
          onCancel();
        }}
        onClose={handleClose}
      /> */}

      {/* Warning Modal */}
      <FeedbackModal
        visible={warningModalVisible}
        type="warning"
        onPrimaryAction={() => {
          onCancel();
        }}
        onSecondaryAction={() => {
          handleClose();
        }}
        onClose={handleClose}
      />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddFinancialInstrument);
